module.exports = __webpack_public_path__ + "static/fonts/manrope-bold.35815d10.woff";